import { render } from "./PlanDetailsModal.vue?vue&type=template&id=6810e2d8&scoped=true"
import script from "./PlanDetailsModal.vue?vue&type=script&lang=js"
export * from "./PlanDetailsModal.vue?vue&type=script&lang=js"

import "./PlanDetailsModal.vue?vue&type=style&index=0&id=6810e2d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6810e2d8"]])

export default __exports__